module.exports = __webpack_public_path__ + "img/4.0a85b1cb.jpg";